import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Returns categories in the same shape your UI expects:
 * [{ id, name, icon, subcategories: [{id,name,description}, ...] }, ...]
 */
export async function fetchCategoriesWithSubcategories() {
  const catsSnap = await getDocs(collection(db, "categories"));

  const categories = await Promise.all(
    catsSnap.docs.map(async (catDoc) => {
      const cat = { ...catDoc.data() };

      const subsSnap = await getDocs(
        collection(db, "categories", catDoc.id, "subcategories")
      );

      const subcategories = subsSnap.docs.map((d) => ({ ...d.data() }));

      return {
        id: cat.id ?? catDoc.id,
        name: cat.name ?? "",
        icon: cat.icon ?? "",
        subcategories,
      };
    })
  );

  // optional: stable sorting
  categories.sort((a, b) => a.name.localeCompare(b.name));
  return categories;
}
